import { Component, ElementRef, Input, OnDestroy, OnInit, ViewChild, ViewChildren } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Config } from '../../config/config';
import { RestDataService } from '../../service/rest-data.service';
import { SharedDataService } from '../../service/shared-data.service';
import { StaticViewDataService } from '../../service/static-view-data-service.service';
import { cloneDeep } from 'lodash';
import { Subject } from 'rxjs';
import { StaticDataService } from '../../service/static-data.service';
import { SnotifyService } from 'ng-snotify';

@Component({
  selector: 'app-analytics-dashboard',
  templateUrl: './analytics-dashboard.component.html',
  styleUrls: ['./analytics-dashboard.component.scss']
})
export class AnalyticsDashboardComponent implements OnInit {
  hourColumn =[];
  hour =[];
  dateColumn = [
  ];
  dateRangeColumn=[];
  notificationListArray=[];
  selectedTab: any = 'last24hours';
  mainSelectedTab: string = 'contentAnalytics';
  summary: any = {  
    "totalStoriesPublished": Number,
    "textStoriesPublished": Number,
    "photoGalleryStoriesPublished": Number,
    "videosStoriesPublished": Number,
    "webStoriesPublished": Number,
    "totalStoriesNotified": Number, 
    "webStoriesNotified": Number,
    "androidStoriesNotified": Number,
    "iosStoriesNotified": Number,
    "storiesWithAutoBacklink": Number,
    "storiesWithCheckedPlagiarism": Number,
    "premiumStories": Number
  }
  flag = false;
  flagfor30 = false;
  data: any;
  userDataResponse: any;
  notificationDataResponse: any;
  tempQuickRead: any;
  quickReadMax: any;
  savingQuickReadInProgress: boolean;
  quickReadSrc: string;
  summaryStatus:string;
  viewParagraph = [];
  userRestrictedSections: any = [];
  userRestrictedStoryTypes: any = [];
  maxPlagiarism: number;
  enableAndDisableSectionHourTable: boolean;
  enableAndDisableUserHourTable: boolean;
  enableNotificationHourPivot: boolean;
  enableAndDisableSectionDateTable: boolean;
  enableAndDisableUserDateTable: boolean;
  enableAndDisableNotificationDateTable: boolean;
  placeholder: string;
  arrowkeyLocation = 0;
  viewObject: { view_id: string; name: string; socketCodes: number[]; subPages: any[]; urls: { listing: string; meta: string; wireGet: string; wirePut: string; suggestion: string; }; fields: string; sortBy: string; apiEndPoints: { api_id: string; name: string; url: string; }[]; headers: ({ header_id: string; name: string; model_id: string; class: string; type: string; } | { header_id: string; name: string; class: string; type: string; model_id?: undefined; })[]; filters: { filter_id: string; name: string; facet_name_meta: string; facet_name: string; type: string; }[]; };
  notificationListUrl: string;
  valueChangeEvent: boolean;
  metaDataUrlNotification: string;
  showLoader = true;
  indexData: number;
  getDailySummaryUrl: string;
  getSummaryUrl: string;
  chosenDate: { beginEpoc: any; endEpoc: any; formatted: boolean; };
  @Input()
  set byAuthor(byAuthor_string: string) {
    this.by_Author = (byAuthor_string && byAuthor_string.trim()) ? byAuthor_string : null;
  }
  by_Author;
  hideListing = false;
  getDataUrl = '';
  getDataDailyUrl = '';
  metaDataUrl = '';
  @ViewChild('listingInput', {static: false}) searchInput: ElementRef;
  socketsAllowed = [];
  filterList = [];
  facets = null;
  notificationFacets = null;
  userFacets = null;
  pageNum = 0;
  listArray = [];
  listIdArray = [];
  noresults = false;
  searchQuery: FormControl = new FormControl();
  pageSize = 50;
  pageSizeArray = [50, 100, 150, 200];
  sortByValueOf = null;
  exactMatch = false;
  filterUrl = {};
  fields = '';
  initialUrl = '';
  latestUrl = '';
  suggestionDataUrl = '';
  callFail = false;
  pages = 0;
  totalRecords = 0;
  listSuggestionArray = [];
  showSuggestionBox = false;
  str = '';
  searchFocus = false;
  showMore = false;
  headerList = [];
  getKeysArray=[];
  getKeysArrayfor30days;
  private subject: Subject<string> = new Subject();
  userKeyArray=[];
  notificationKeyArray=[];
  userDailyArray;
  userData = [];
  monthNames = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
  ];
  isGenerateReportClicked:boolean = false;
  @ViewChildren('listData2') listData: ElementRef;
  timings = {
    constr: 0,
    onin: 0,
    resp: 0,
    list: 0,
    getEnv: 0,
    getMeta: 0
  };
  domainConfig = null;
  showMy = false;
  getUserHourlyUrl: string;
  getUserDailyUrl: string;
  getNotificationHourlyUrl: string;
  getNotificationDailyUrl: string;
  getDateRangeUrl: string;
  getUserDateRangeUrl: string;
  getNotificationDateRangeUrl: string;
  constructor(
    private config: Config,
    private sharedService: SharedDataService,
    private restService: RestDataService,
    private snotify: SnotifyService,
  ) {
    const d = new Date();
    let hourtime = d.getHours();
    let hourColumnData=this.createHourArray(hourtime,hourtime-1);
    this.hourColumn = this.last24HourList(hourColumnData);
    let hourData = this.createHourArray(hourtime+1,hourtime);
    this.hour = this.last24HourList(hourData);
  }


  ngOnInit() {
    
   this.socketsAllowed = StaticViewDataService.Analytics_listing_View.socketCodes;
   const filters = StaticViewDataService.Analytics_listing_View.filters;
   this.filterList = this.sharedService.getUpdatedFilters(filters);
   var todayDate = new Date();
   this.dateColumn[0]= todayDate.toISOString().slice(0, 10);
   for(var i = 1; i<30; i=i+1){
     var date = todayDate.setDate(todayDate.getDate()-1);
     var d = new Date(date);
     this.dateColumn[i]= d.toISOString().slice(0, 10);
   }
   this.setApiUrl();
   this.getMetaData();
   this.tabopen('last24hours');
  }

  last24HourList(list) {
    let array =[];
    let sortedArray = []
    list.forEach((e,index)=>{
      if(index===0) {
       sortedArray[0] = e
      } else {
        array.push(e);
      }
    })
    array = array.reverse();
    array.forEach(e=>{
      sortedArray.push(e);
    })
    return sortedArray;
  }

  setApiUrl() {
    this.getSummaryUrl = this.config.get('product').baseUrl + '/api/cms/analytics/';
    this.getDailySummaryUrl = this.config.get('product').baseUrl + '/api/cms/analytics/lastmonth';
    this.getDataUrl = this.config.get('product').baseUrl + StaticViewDataService.Analytics_listing_View.urls.data;
    this.getDataDailyUrl = this.config.get('product').baseUrl + StaticViewDataService.Analytics_listing_View.urls.data2;
    this.metaDataUrl = this.config.get('product').baseUrl + StaticViewDataService.Analytics_listing_View.urls.meta;
    this.getUserDailyUrl = this.config.get('product').baseUrl + StaticViewDataService.Analytics_listing_View.urls.userDataDaily;
    this.getUserHourlyUrl = this.config.get('product').baseUrl + StaticViewDataService.Analytics_listing_View.urls.userDataHourly;
    this.getNotificationDailyUrl = this.config.get('product').baseUrl + StaticViewDataService.Analytics_listing_View.urls.notificationDataDaily;
    this.getNotificationHourlyUrl = this.config.get('product').baseUrl + StaticViewDataService.Analytics_listing_View.urls.notificationDataHourly;
    this.getDateRangeUrl = this.config.get('product').baseUrl + StaticViewDataService.Analytics_listing_View.urls.daterange;
    this.getUserDateRangeUrl = this.config.get('product').baseUrl + StaticViewDataService.Analytics_listing_View.urls.userDaterange;
    this.getNotificationDateRangeUrl = this.config.get('product').baseUrl+ StaticViewDataService.Analytics_listing_View.urls.notificationDaterange;
  }

  getSummaryData() {
    let url;
    this.flagfor30 ? url = this.getDailySummaryUrl : url = this.getSummaryUrl;

    if (this.selectedTab === "daterange" && this.chosenDate) {
      url = this.getSummaryUrl + '?startDate=' + new Date(this.chosenDate.beginEpoc).getTime() 
                + '&endDate=' + new Date(this.chosenDate.endEpoc).getTime();
    }

    if (url && url.trim() !== '') {
      this.restService.http_get(url)
        .subscribe(data => {
          this.summary = data;
          this.flag = true;
        });
    }
  }

  getMetaData() {
    if (this.metaDataUrl && this.metaDataUrl.trim() !== '') {
      this.restService.http_get(this.metaDataUrl)
        .subscribe(data => {
          this.userFacets = { ...data, ...this.facets };
          this.facets = this.userFacets;
          this.facets['premiumStory'] = {true:0, false:0};
          this.facets['opengeneric'] = {true:0, false:0};
          this.facets['source'] = {PRINT:0,DIGITAL:0};
        });
    } 
  }

  getUserSessionData() {
    let url;
    this.flagfor30 ? url = this.getDataDailyUrl : url = this.getDataUrl;
    if (url && url.trim() !== '') {
      this.restService.http_get(url)
        .subscribe(data => {
          this.showLoader = false;
          this.data = data;
          let key = Object.keys( this.data );
          let keyArray = this.sortArrayData(key);  
         this.getKeysArray = keyArray;
        }, error=>{
          this.snotify.error('Failed to fetch section table data', '', this.sharedService.getConfig(false));
        });
    }
  }

  getUserData() {
    let url;
    this.flagfor30 ? url = this.getUserDailyUrl : url = this.getUserHourlyUrl;
    if (url && url.trim() !== '') {
      this.restService.http_get(url)
        .subscribe(data => {
          this.showLoader = false;
          this.userDataResponse = data;
          let key = Object.keys( this.userDataResponse );
          let keyArray = this.sortArrayData(key);  
          this.userKeyArray = keyArray;
        }, error=>{
          this.snotify.error('Failed to fetch user table data', '', this.sharedService.getConfig(false));
        });
    }
  }

  getNotificationData() {
    let url;
    this.flagfor30 ? url = this.getNotificationDailyUrl : url = this.getNotificationHourlyUrl;
    if (url && url.trim() !== '') {
      this.restService.http_get(url)
        .subscribe(data => {
          this.showLoader = false;         
          let key = Object.keys(data);
          this.notificationDataResponse = this.mapNotificationResponse(data);
          let keyArray = this.sortArrayData(key);  
          this.notificationKeyArray = keyArray;
        }, error=>{
          this.snotify.error('Failed to fetch notification table data', '', this.sharedService.getConfig(false));
        });
    }
  }

  mapNotificationResponse(res) {
    let key = Object.keys(res);
    let value = [];
    let notificationData = [];
    let newObj = {};
    let sortArray = [];
    value = Object.values(res);
    value.forEach(element => {
      element.forEach(e=>{
       if(e.platforms == 'Web') {
        sortArray.push(e)
       }
      })
    })
    value.forEach(element => {
      element.forEach(e=>{
       if(e.platforms == 'Android') {
        sortArray.push(e)
       }
      })
    })
    value.forEach(element => {
      element.forEach(e=>{
       if(e.platforms == 'Iphone') {
        sortArray.push(e)
       }
      })
    })

    sortArray.forEach(e=>{
        if(notificationData && notificationData.length> 0 && notificationData.some((item) => item.key == e.key && item.date == e.date)) {
          notificationData.forEach(data=>{
            this.showLoader = false;
              if(data.key === e.key && data.date === e.date) {
                data.platforms = data.platforms + '/' + e.platforms
                data.count = data.count + '/' + e.count
              } 
             })
        } else {
          notificationData.push(cloneDeep(e));
        }
      })

    notificationData.forEach(e=>{
        const check = isNaN(cloneDeep(e.count));
        const data = e.platforms.split('/');
        const count = check ? e.count.split('/'): '';
        let androidCount = 0;
        let webCount = 0;
        let iosCount = 0;
        this.indexData = 0;
        data.forEach(element=> {
          if(element == 'Web') {
            webCount = check ? count[this.indexData] : e.count;
            this.indexData = this.indexData + 1;
          }
          if(element == 'Android') {
            androidCount = check ? count[this.indexData] : e.count;
            this.indexData= this.indexData +1;
          }
          if(element == 'Iphone') {
            iosCount = check ? count[this.indexData] : e.count;
          }
        e.count = webCount+'/'+ androidCount+'/'+ iosCount;
       })
      })
   
    key.forEach(element=>{
      let newArray = [];
      notificationData.forEach(result=>{
        if(element == result.key) {
          newArray.push(result);
          newObj[element] = newArray;
        }
      })
    })
    return newObj;
  }

  sortArrayData(key) {
    let keyArray = []
    if(key.includes('Total')){
      keyArray.push('Total')
    }
    key.forEach(e=>{
      if(e!=='Total'){
        keyArray.push(e)
      }
    });
    return keyArray;
  }

  expandCollapsTable(type){
    if(type === 'enableAndDisableSectionHourTable'){
      this.enableAndDisableSectionHourTable = !this.enableAndDisableSectionHourTable
    }
    if(type === 'enableAndDisableUserHourTable') {
      this.enableAndDisableUserHourTable = !this.enableAndDisableUserHourTable
    }
    if(type === 'enableNotificationHourPivot') {
      this.enableNotificationHourPivot = !this.enableNotificationHourPivot
    }
    if(type === 'enableAndDisableSectionDateTable') {
      this.enableAndDisableSectionDateTable = !this.enableAndDisableSectionDateTable
    }
    if(type === 'enableAndDisableUserDateTable') {
      this.enableAndDisableUserDateTable = !this.enableAndDisableUserDateTable
    }
    if(type === 'enableAndDisableNotificationDateTable') {
      this.enableAndDisableNotificationDateTable = !this.enableAndDisableNotificationDateTable
    }
  }

  getFilterData(facet_name) {
    if (this.facets && this.facets[facet_name]) {
      if(facet_name==='CreatedBy' || facet_name === 'NotificationType') {
        let fact = {};
        this.facets[facet_name].forEach(e=>{
            fact[e] = e;
        });
        return fact;
      } else {
        return this.facets[facet_name];
      }
    } else {
      return null;
    }
  }

  urlUpdate(ev) {
    this.filterUrl[ev.type] = ev.data;
    this.pageNum = 0;
    this.searchResults(this.str, this.pageNum, this.dataInsertion);
  }

  searchResults(query, pageNum, callback) {
    this.getSummaryData();
    this.getDefaultList(pageNum, data => {
      callback(data);
    });
    this.getUserFilteredList(pageNum, data => {
      callback(data);
    });
    this.getNotificationrFilteredList(pageNum, data => {
      callback(data);
    });
  }

  getNotificationrFilteredList(pageNum, callback) {
    let url;
    this.flagfor30 ? url = this.getNotificationDailyUrl : url = this.getNotificationHourlyUrl;
    url += '?&search=';
    if(this.selectedTab==="daterange" && this.chosenDate)
    {
      url = this.getNotificationDateRangeUrl+'?&search=,notificationDateTime>'+
    new Date(this.chosenDate.beginEpoc).getTime()+',notificationDateTime<'+
    new Date(this.chosenDate.endEpoc).getTime();
  }
    if (this.filterUrl) {
      for (const filter in this.filterUrl) {
        if (filter) {        
          url += this.filterUrl[filter];
        }
      }
    }
    this.callFail = false;
    if (this.initialUrl === '') {
      this.initialUrl = url;
    }
    this.latestUrl = url;
    this.timings['firstGet'] = performance.now();
    this.restService.http_get(url)
      .subscribe(data => {
        this.timings.resp = performance.now();
        this.pages = data['totalPages'] > 20 ? 20 : data['totalPages'];
        this.totalRecords = data['totalElements'];
        this.callFail = false;
        this.topFunction();
        this.measureTime(0);
        let key = Object.keys(data);
        let keyArray = this.sortArrayData(key);  
        this.notificationDataResponse = this.mapNotificationResponse(data);
        this.notificationKeyArray = keyArray;
        callback(data);
      });
  }

  getUserFilteredList(pageNum, callback) {
    let url;
    this.flagfor30 ?  url = this.getUserDailyUrl :  url = this.getUserHourlyUrl;
     url += '?&search=';
     if(this.selectedTab==="daterange" && this.chosenDate)
    url = this.getUserDateRangeUrl+'?&search=,firstPublishedDate>'+
    new Date(this.chosenDate.beginEpoc).getTime()+',firstPublishedDate<'+
    new Date(this.chosenDate.endEpoc).getTime();
    if (this.filterUrl) {
      for (const filter in this.filterUrl) {
        if (filter) {        
          url += this.filterUrl[filter];
        }
      }
    }
    this.callFail = false;
    if (this.initialUrl === '') {
      this.initialUrl = url;
    }
    this.latestUrl = url;
    this.timings['firstGet'] = performance.now();
    this.restService.http_get(url)
      .subscribe(data => {
        this.timings.resp = performance.now();
        this.callFail = false;
        this.topFunction();
        this.measureTime(0);
        let key = Object.keys(data);
        let keyArray = this.sortArrayData(key);  
        this.userDataResponse=data;
        this.userKeyArray = keyArray;
        callback(data);
      });
  }

  getDefaultList(pageNum, callback) {
    let url;
    this.flagfor30 ?  url = this.getDataDailyUrl :  url = this.getDataUrl;
     url += '?&search=';
    console.log(this.selectedTab + " "+ this.chosenDate);
    if(this.selectedTab==="daterange" && this.chosenDate){
    url = this.getDateRangeUrl+'?&search=,firstPublishedDate>'+
    new Date(this.chosenDate.beginEpoc).getTime()+',firstPublishedDate<'+
    new Date(this.chosenDate.endEpoc).getTime();
     }
    if (this.filterUrl) {
      for (const filter in this.filterUrl) {
        if (filter) {        
          url += this.filterUrl[filter];
        }
      }
    }
    this.callFail = false;
    if (this.initialUrl === '') {
      this.initialUrl = url;
    }
    this.latestUrl = url;
    this.timings['firstGet'] = performance.now();
    this.restService.http_get(url)
      .subscribe(data => {
        this.timings.resp = performance.now();
        this.pages = data['totalPages'] > 20 ? 20 : data['totalPages'];
        this.totalRecords = data['totalElements'];
        this.callFail = false;
        this.topFunction();
        this.measureTime(0);
        let key = Object.keys(data);
        let keyArray = this.sortArrayData(key);  
        this.data=data;
        this.getKeysArray = keyArray;
        callback(data);
      });
  }

  dataInsertion = (data) => {
    const results = data['content'];
    this.listArray = [];
    this.listIdArray = [];
    if (results && results.length > 0) {
      this.listArray = results;
      this.listIdArray = results.map(e => e.id);
      this.noresults = false;
    } else {
      this.noresults = true;
    }
  }

  topFunction() {
    document.body.scrollTop = 0; // For Safari
    if (document.getElementsByClassName('contentList') && document.getElementsByClassName('contentList').length > 0) {
      document.getElementsByClassName('contentList')[0].scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }
  }

  measureTime(count) {
    if (this.listData['length'] === this.pageSize) {
      this.timings.list = performance.now();
    } else if (count < 6) {
      setTimeout(e => {
        this.measureTime(++count);
      }, 0);
    }
  }

  tabopen(tab) {
    this.selectedTab = tab;
    this.flag = false;
    this.showLoader = true;
    tab === 'last24hours' ?  this.flagfor30=false : this.flagfor30=true;
    if(tab!='daterange'){
    this.getSummaryData();
    this.getUserSessionData();
    this.getUserData();
    this.getNotificationData();
    } else {
      this.showLoader = false;
    }
  }

  createHourArray(start, end)
  {
    var arr=[];
    for(let i= start;i<=23;i++)
    {
      arr.push(i.toString());
    }
    for(let i =0;i<=end;i++)
    {
      arr.push(i.toString());
    }
    return arr;
  }
  selectedDate(value: any, datepicker?: any) {
    this.chosenDate = {
      beginEpoc: value.start,
      endEpoc: value.end,
      formatted: true
    };
  }

  calendarEventsHandler(e: any, datepicker?: any) {
    // console.log(this.name)
    if (e.event.type === 'apply') {
      console.log(this.chosenDate)
    }
    if (e.event.type === 'cancel') {
      this.chosenDate = null;
    }
  }
  getNewTypeDateRange(datestring) {
    if (datestring) {
      if (typeof datestring === 'string') {
        const dt = new Date(datestring.replace('+0000', 'Z'));
        return this.getDateRange(Math.round(dt.getTime()));
      } else {
        // console.log(datestring)
        return this.getDateRange(datestring);
      }
    } else {
      return 'not present';
    }
  }
  getDateRange(seconds) {
    if (seconds) {
      const date = new Date(seconds);
      return '' + this.monthNames[date.getMonth()] + ' ' + date.getDate() + ', ' + ' ' + date.getFullYear() ;
    } else {
      return 'not present';
    }
  }
  generateReport(){
    if(this.chosenDate){
      this.isGenerateReportClicked = true;
      this.dateRangeColumn =[];
      var startDate = new Date(this.chosenDate.beginEpoc);
      this.dateRangeColumn[0] = startDate.toISOString().slice(0, 10);
      var endDate = new Date(this.chosenDate.endEpoc);
      var currentDate = new Date(startDate);
      currentDate.setHours(0, 0, 0, 0); // set time to 00:00:00
      var i = 0;
      while (currentDate <= endDate) {
        currentDate.setDate(currentDate.getDate() + 1);
        this.dateRangeColumn[i] = currentDate.toISOString().slice(0, 10);
        i++;
      }
      delete this.filterUrl['genericopenstory'];
      delete this.filterUrl['metadata.storyType'];
      delete this.filterUrl['type'];
      delete this.filterUrl['metadata.premiumStory'];
      this.searchResults(this.str, this.pageNum, this.dataInsertion);
    }
    else{
    this.snotify.error("Please select a date.", '', this.sharedService.getConfig(false));
    }
  }
  
}
